import React, {memo, useEffect, useMemo, useState} from "react";
import PropTypes from "prop-types";
import {Routes, Route, Navigate, useLocation} from "react-router-dom";
import {useSelector} from "react-redux";
// import loadable from '@loadable/component';
import {
  getIsAllowedPermissionV2,
  SetGlobalAccountUuidReducer,
  GetGlobalAccountReducer,
  GlobalNavigate,
  InitGlobalRoute,
} from "../../Helpers";
import {ErrorsComponent} from "../../Components";
import {useQuery} from "../../Hooks/Query.Hook";
import moment from "moment";
import {SelfServicesCardEnum} from "../../enums/Shared/SelfServicesCard.Enum";
import i18next from "i18next";
import {RedirectionSection} from "./Sections";

export const SwitchRouteComponent = memo(({routes}) => {
  const query = useQuery();
  const permissionsReducer = useSelector(
    (state) => state?.PermissionsReducer?.permissions
  );
  const location = useLocation();
  const [route, setRoute] = useState({
    //--> it can be replaced with useRef or localStorage
    to: location.pathname,
    from: location.pathname,
  });

  useEffect(() => {
    setRoute((prev) => ({to: location.pathname, from: prev.to}));
  }, [location]);
  useEffect(() => {
    InitGlobalRoute({route});
  }, [route]);

  useEffect(() => {
    if (window.location.pathname.includes("accounts")) return;
    let queriesString = "";
    Array.from(query.entries()).forEach(([key, value]) => {
      queriesString = `${queriesString}${
        (queriesString && "&") || ""
      }${key}=${value}`;
    });

    if (
      !(GetGlobalAccountReducer() || JSON.parse(localStorage.getItem("system_user")))
    ) {
      const source = query.get('source');
      const isNumberSource = source && !isNaN(+source);
      const isQueryHasRedirectPathOrSource
          = queriesString.includes('redirect_path')
          || (queriesString.includes('source=') && isNumberSource)
          || queriesString.includes('redirect_page=');
      const redirectPathQuery =
        !isQueryHasRedirectPathOrSource &&
        `redirect_path=${window.location.pathname}`;
      const loginQueriesString = [queriesString, redirectPathQuery]
        .filter(Boolean)
        .join("&");
      GlobalNavigate(
        `/accounts/login${(loginQueriesString && "?" + loginQueriesString) || ""}`
      );
    }

    const key = query.get("token_key");
    const account_uuid = query.get("account_uuid");
    const pagePath = query.get("redirect_page");
    const user_uuid = query.get("user_uuid");
    const approval_uuid = query.get("approval_uuid");
    const user_local = JSON.parse(localStorage.getItem("system_user"));
    if (account_uuid) {
      localStorage.setItem("account_uuid", account_uuid);
      SetGlobalAccountUuidReducer(account_uuid);
    }
    if (key && !approval_uuid) {
      const isExpired = moment().isAfter(
        moment
          .unix(JSON.parse(localStorage.getItem("user_token_expiry")))
          .format()
      );
      if (
        !isExpired &&
        user_local?.uuid === user_uuid &&
        localStorage.getItem("permissionsReducer")
      ) {
        if (pagePath) {
          const redirectPage = Object.values(SelfServicesCardEnum).find(
            (v) => v.key === +pagePath
          );
          if (redirectPage) GlobalNavigate(`/home/${redirectPage?.value}`);
          else
            GlobalNavigate(
              `/home/self-service${queriesString && "?" + queriesString}`
            );
        } else {
          GlobalNavigate(
            `/home/self-service${queriesString && "?" + queriesString}`
          );
        }
      } else {
        GlobalNavigate(
          `/accounts/login${queriesString && "?" + queriesString}`
        );
      }
    }
  }, [query]);

  const getRoutesList = useMemo(
    () =>
      // eslint-disable-next-line react/display-name
      (localRoutes = routes, parentIndex = 0) => {
        let defaultRoutePath = null;

        return localRoutes
          .filter((route) => route.isRoute && route.component)
          .map((route, index) => {
            if (index === 0) defaultRoutePath = null;
            const ComponentToRender =
              (((!route.defaultPermissions && !route.permissionId) ||
                getIsAllowedPermissionV2({
                  defaultPermissions: route.defaultPermissions,
                  permissions: route.permissions || permissionsReducer || [],
                  permissionId: route.permissionId,
                  allowEmptyRules: true,
                })) &&
                route.component) ||
              null;
            defaultRoutePath =
              defaultRoutePath ||
              (route.layout && route.layout + "/" + route.path) ||
              route.path;

            return (
              <React.Fragment
                key={`switchRoutesKey${parentIndex}-${index}${i18next.language}`}
              >
                <Route
                  element={
                    (ComponentToRender && <ComponentToRender />) || (
                      <ErrorsComponent />
                    )
                  }
                  path={route.path}
                >
                  {route &&
                    route.children &&
                    route.children.length > 0 &&
                    getRoutesList(route.children, index)}
                </Route>
                {(route.default && (
                  <Route
                    index
                    element={
                      <RedirectionSection redirectPath={defaultRoutePath} />
                    }
                  />
                )) ||
                  undefined}
                {index === localRoutes.length - 1 && (
                  <Route
                    path="*"
                    element={<Navigate to={`/${defaultRoutePath}`.replace(/\/+/g, "/")} replace />}
                  />
                )}
              </React.Fragment>
            );
          });
      },
    [permissionsReducer, routes]
  );

  return (
    <Routes>
      {getRoutesList()}
      <Route path="*" component={<Navigate to="accounts/login" replace />} />
    </Routes>
  );
});

SwitchRouteComponent.displayName = "SwitchRouteComponent";
SwitchRouteComponent.propTypes = {
  routes: PropTypes.instanceOf(Array).isRequired,
};
